import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"
import Step from "@fae/source/models/Step.js"
import Audiomix from "@fae/source/engine/Audiomix.js"

// const LEVEL = 3
// "level": LEVEL
// "maxhealth": 20 + (LEVEL * 10)
// "power": 10 + (LEVEL * 10)
// "maxexperience": Math.pow(20, LEVEL) * 10

export default {
    "affiliation": "good",
    "overworld": {
        "currentTime": 0,
    },
    "units": {
        "teacher": {
            "key": "teacher",
            "jobKey": "school/teacher",
            "isRecruited": true,
        },
        "nerd": {
            "key": "nerd",
            "jobKey": "school/nerd",
            "isRecruited": true,
            "experience": 0,
        },
        "punk": {
            "key": "punk",
            "jobKey": "school/punk",
            "experience": 0,
        },
        "goth": {
            "key": "goth",
            "jobKey": "school/goth",
            "experience": 0,
        },
    }
}
